let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eTNAU")).then(() => parcelRequire('lH6SX'));